<!-- ICONS ordered alphabetically -->

<!-- htmllint attr-new-line="false" -->
<!-- htmllint tag-close="false" -->
<!-- htmllint tag-name-lowercase="false" -->
<!-- htmllint attr-bans="false" -->
<svg
  xmlns:dc="http://purl.org/dc/elements/1.1/"
  xmlns:cc="http://creativecommons.org/ns#"
  xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
  xmlns:svg="http://www.w3.org/2000/svg"
  xmlns="http://www.w3.org/2000/svg"
  version="1.1">
  <title>Inditex</title>
  <defs>
    <symbol id="small-arrow" viewBox="0 0 129 129">
      <path d="m88.6,121.3c0.8,0.8 1.8,1.2 2.9,1.2s2.1-0.4 2.9-1.2c1.6-1.6 1.6-4.2 0-5.8l-51-51 51-51c1.6-1.6 1.6-4.2 0-5.8s-4.2-1.6-5.8,0l-54,53.9c-1.6,1.6-1.6,4.2 0,5.8l54,53.9z" />
    </symbol>
    <symbol id="dropdown" viewBox="0 0 16 16">
      <path d="M16 5.3L9.1 12c-.6.7-1.6.7-2.2 0L0 5.3 2.3 3 8 8.7 13.7 3 16 5.3z"/>
    </symbol>
    <symbol id="cross" viewBox="0 0 16 16">
      <path d="M16 1.6L14.4 0 8 6.4 1.6 0 0 1.6 6.4 8 0 14.4 1.6 16 8 9.6l6.4 6.4 1.6-1.6L9.6 8 16 1.6z"/>
    </symbol>
    <symbol id="cart" viewBox="0 0 16 16">
      <path d="M0 .76V2.4h1.06l3.78 9.07a.8.8 0 0 0 .76.53h7.18c.38 0 .64-.22.75-.53l2.42-6.42a.8.8 0 0 0-.75-1.06H3.48L2.34 1.29A.8.8 0 0 0 1.6.76zM4.16 5.6h9.9l-1.81 4.8H6.12zm2.65 7.98a1.21 1.21 0 1 0 0 2.42 1.21 1.21 0 0 0 0-2.42zm4.76 0a1.21 1.21 0 1 0 0 2.42 1.21 1.21 0 0 0 0-2.42z"/>
    </symbol>
  </defs>
</svg>
